import {
  Box,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { TableColumn } from "../../../types/tableColumn";

//TODO to many any types..

type CustomTableProps = {
  columns: TableColumn[];
  data: any[];
  title: string;
  defaultRowsPrPage: number;
};

export default function CustomTable({
  columns,
  data = [],
  title,
  defaultRowsPrPage = 10,
}: CustomTableProps) {
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPrPage);
  const [page, setPage] = useState<number>(0);

  function descendingComparator(a: any, b: any, orderBy: any) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order: "asc" | "desc", orderBy: any) {
    return order === "desc"
      ? (a: any, b: any) => descendingComparator(a, b, orderBy)
      : (a: any, b: any) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array: any[], comparator: (a: any, b: any) => number) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a: any, b: any) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const handleRequestSort = (_: any, property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event?.target.value, 10));
    setPage(0);
  };

  return (
    <Paper sx={{borderRadius: "10px"}}>
      <Box display={"flex"} p={2} width="100%">
        <Typography variant="h4" color={"primary"}>
          {title}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Box>{/* here print icons etc should be */}</Box>
      </Box>
      <Divider />
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((c, index) => {
                return (
                  <TableCell key={index}>
                    {c.sort ? (
                      <TableSortLabel
                        active={orderBy === c.key}
                        onClick={(e) => handleRequestSort(e, c.key)}
                        direction={orderBy === c.key ? order : "asc"}
                      >
                        {c.label}
                      </TableSortLabel>
                    ) : (
                      c.label
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row: number, rowIndex: number) => (
                <TableRow key={rowIndex} hover>
                  {columns.map((column: TableColumn, columnIndex: number) => {
                    // Split the key string by '.' to handle nested properties

                    const keys = column.key.split(".");

                    // Reduce the row object by traversing it with the keys array, with checks for undefined
                    const value = keys.reduce<any>(
                      (acc, key) =>
                        acc && acc[key] !== undefined ? acc[key] : undefined,
                      row
                    );

                    const Cell = column ? column.Cell : null;
                    return (
                      <TableCell key={columnIndex}>
                        {Cell ? (
                          <Cell value={value} />
                        ) : value !== undefined ? (
                          value
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Divider />
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50, 75, 100]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
